import { FaqItem, TestimonialItem } from '../types';

export const faqsData: FaqItem[] = [
  {
    question: "What services does EBON Media Solutions offer?",
    answer: "EBON Media Solutions specializes in end-to-end technology and digital growth services, including AI Website Development, Hybrid Mobile App Development, Custom Software Solutions, ERP Development & Implementation, SaaS Product Engineering, and Data-Driven Digital Marketing."
  },
  {
    question: "Can you develop custom websites and mobile applications?",
    answer: "Yes, absolutely. We design and build bespoke websites and mobile applications from the ground up, utilizing modern tech stacks like React, Next.js, React Native, and Flutter. Every project is tailored specifically to your brand identity, business workflows, and user requirements."
  },
  {
    question: "Do you provide ERP and SaaS development?",
    answer: "Yes. We engineer scalable, multi-tenant SaaS products and integrated enterprise resource planning (ERP) systems. Our solutions cover automated inventory management, procurement workflows, role-based access control, billing engines, and unified executive dashboards."
  },
  {
    question: "Can you integrate AI into an existing business solution?",
    answer: "Yes. You do not always need to rebuild your software from scratch. We integrate modular artificial intelligence capabilities—such as automated customer assistants, semantic search, vector knowledge retrieval, document parsing, and predictive analytics—into your existing platforms and databases via secure APIs."
  },
  {
    question: "Do you offer ongoing maintenance and support?",
    answer: "Yes. We provide continuous application maintenance, security patching, cloud infrastructure monitoring, OS compatibility updates, performance optimization, and dedicated SLA-backed technical support to ensure your digital products run smoothly 24/7."
  },
  {
    question: "How can I request a project consultation?",
    answer: "You can request a consultation by clicking the 'Book a Consultation' button in our header, filling out the inquiry form on our homepage or Contact Us page, or reaching out directly via phone at +91 7307718079 or email at info@ebonmedia.com. Our technology specialists typically respond within 24 business hours."
  }
];

export const testimonialsData: TestimonialItem[] = [
  {
    id: 'test-1',
    quote: "EBON Media Solutions delivered exceptional website engineering for our platform. They modernized our web portal with clean Next.js architecture and rapid load times. The delivery was disciplined, communication was smooth, and user retention has improved noticeably.",
    clientName: "David Miller",
    role: "VP of Product",
    company: "Vanguard Tech Solutions",
    location: "Austin, Texas",
    country: "US",
    countryFlag: "🇺🇸",
    serviceCategory: "Website Development",
    rating: 5.0,
    projectDomain: "Enterprise Web Platform",
    metric: "Fast Delivery | Zero Latency",
    verified: false
  },
  {
    id: 'test-2',
    quote: "Developing a hybrid mobile application that feels truly fluid on both iOS and Android requires top-tier development rigor. EBON Media built our fintech app with biometric login and reliable offline synchronization. Apple App Store and Google Play approvals went smoothly on our first try.",
    clientName: "Sarah Jenkins",
    role: "Operations Director",
    company: "FinVeloce Payments",
    location: "London, UK",
    country: "UK",
    countryFlag: "🇬🇧",
    serviceCategory: "Mobile App Services",
    rating: 4.9,
    projectDomain: "Cross-Platform Mobile Application",
    metric: "App Store Approved",
    verified: false
  },
  {
    id: 'test-3',
    quote: "EBON Media provided dependable mobile app engineering for our health workflow application. They handled secure audio-video sessions, sensor pairing, and automated push notifications reliably. We hit our planned release date without cutting corners.",
    clientName: "Michael Chang",
    role: "Head of Technology",
    company: "AuraHealth Technologies",
    location: "New York, NY",
    country: "US",
    countryFlag: "🇺🇸",
    serviceCategory: "Mobile App Services",
    rating: 4.8,
    projectDomain: "Cross-Platform Telehealth App",
    metric: "High Uptime & Reliability",
    verified: false
  },
  {
    id: 'test-4',
    quote: "The web application built by EBON Media Solutions provided our retail customers with seamless, fast navigation and checkout flows. The codebase is clean, well-documented, and easily maintainable by our internal developers.",
    clientName: "James Wilson",
    role: "E-Commerce Director",
    company: "Albion Goods Co.",
    location: "Manchester, UK",
    country: "UK",
    countryFlag: "🇬🇧",
    serviceCategory: "Website Development",
    rating: 4.9,
    projectDomain: "Modern E-Commerce Web Platform",
    metric: "Fast Checkout & High Uptime",
    verified: false
  },
  {
    id: 'test-5',
    quote: "We needed a clean, corporate web presence for our consulting clients. The EBON Media team delivered a responsive, polished website with sharp layout structures and fast mobile loading.",
    clientName: "Emily Roberts",
    role: "Managing Director",
    company: "Horizon B2B Advisory",
    location: "Chicago, IL",
    country: "US",
    countryFlag: "🇺🇸",
    serviceCategory: "Website Development",
    rating: 5.0,
    projectDomain: "Modern B2B Corporate Website",
    metric: "Responsive Web Design",
    verified: false
  },
  {
    id: 'test-6',
    quote: "EBON Media engineered our field dispatch and telematics mobile application for iOS and Android. Offline syncing, reliable driver interfaces, and continuous performance under low-connectivity areas make it a solid tool for our fleet.",
    clientName: "Julian Thorne",
    role: "Chief Technology Officer",
    company: "LogixPulse Fleet Systems",
    location: "Birmingham, UK",
    country: "UK",
    countryFlag: "🇬🇧",
    serviceCategory: "Mobile App Services",
    rating: 4.9,
    projectDomain: "Fleet Logistics Mobile App",
    metric: "Offline Caching & Sync",
    verified: false
  }
];
